// ...existing code...
export default class Marquee {
  constructor(selector, items = [], options = {}) {
    this.root = document.querySelector(selector);
    if (!this.root) return;

    this.options = options || {};
    // separator defaults
    this.separator = Object.assign({
      type: 'star',           // 'star' | 'line' | 'text' | 'icon' (affects default rendering)
      content: '★',          // used for 'star', 'text' or 'icon'
      className: 'separator-custom', // custom CSS class you can style in SCSS
      spacing: '60px'         // horizontal spacing around separator
    }, this.options.separator || {});

    this.items = items.length ? items : [
      "Digital Strategy",
      "Design System",
      "Brand Strategy",
      "Website Design",
      "SEO Optimization",
      "Content Strategy"
    ];

    this.hScrollElems = [...this.root.querySelectorAll('.text-scroll')];
    this.vScrollElems = [...this.root.querySelectorAll('.vertical-text-scroll')];
    this.init();
  }

  init() {
    this.hScrollElems.forEach(el => el.innerHTML = '');
    this.vScrollElems.forEach(el => el.innerHTML = '');

    // populate twice for seamless -50% translate
    this.items.forEach(item => this.addItemToScrolls(item));
    this.items.forEach(item => this.addItemToScrolls(item));
  }

  addItemToScrolls(text) {
    this.hScrollElems.forEach(scrollItem => {
      const textItem = document.createElement('span');
      textItem.className = 'text-item';
      textItem.textContent = text;
      scrollItem.appendChild(textItem);

      const sep = this.createSeparator();
      scrollItem.appendChild(sep);
    });

    this.vScrollElems.forEach(scrollItem => {
      const textItem = document.createElement('span');
      textItem.className = 'vertical-text-item';
      const firstWord = text.split(' ')[0];
      textItem.textContent = firstWord;
      scrollItem.appendChild(textItem);

      const sep = this.createSeparator();
      scrollItem.appendChild(sep);
    });
  }

  createSeparator() {
    const sep = document.createElement('span');
    sep.classList.add('separator');

    // add the custom class (empty by default so you can style it)
    if (this.separator.className) sep.classList.add(this.separator.className);

    // also add a type class for optional default styles (optional)
    if (this.separator.type) sep.classList.add(this.separator.type);

    // assign content for text/icon/star types
    if (this.separator.type === 'text' || this.separator.type === 'star' || this.separator.type === 'icon') {
      sep.textContent = this.separator.content || '';
    }
    // spacing applied inline for easy override from JS options
    sep.style.margin = `0 ${this.separator.spacing}`;

    return sep;
  }
}